module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('mu-appbar', [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n            Vue-Layout\n            "), _c('mu-badge', {
    staticClass: "description",
    attrs: {
      "content": "可视化布局 ",
      "color": "#f06292"
    }
  })], 1), _vm._v(" "), _c('mu-icon-button', {
    attrs: {
      "icon": "share"
    },
    on: {
      "click": function($event) {
        _vm.share.open = true
      }
    },
    slot: "right"
  }), _vm._v(" "), _c('mu-icon-button', {
    attrs: {
      "icon": "settings"
    },
    on: {
      "click": function($event) {
        _vm.setting.open = true
      }
    },
    slot: "right"
  }), _vm._v(" "), _c('mu-icon-button', {
    attrs: {
      "icon": ":iconfont icon-github",
      "href": "https://github.com/jaweii/Vue-Layout"
    },
    slot: "right"
  })], 1), _vm._v(" "), _c('mu-row', {
    staticClass: "main-content"
  }, [_c('mu-col', {
    staticClass: "attributes",
    attrs: {
      "width": _vm.width.attr,
      "tablet": _vm.width.attr,
      "desktop": _vm.width.attr
    }
  }, [_c('mu-sub-header', {
    staticClass: "header"
  }, [_c('mu-select-field', {
    staticClass: "select-field",
    attrs: {
      "autoWidth": ""
    },
    model: {
      value: (_vm.selectField.value),
      callback: function($$v) {
        _vm.selectField.value = $$v
      },
      expression: "selectField.value"
    }
  }, [_c('mu-menu-item', {
    attrs: {
      "title": "属性",
      "value": "属性"
    }
  }), _vm._v(" "), _c('mu-menu-item', {
    attrs: {
      "title": "组件树",
      "value": "组件树"
    }
  })], 1), _vm._v(" "), _c('span', [(_vm.parentComponent) ? _c('a', {
    staticClass: "parent-component",
    on: {
      "click": _vm.switchComponent
    }
  }, [_vm._v("┡ " + _vm._s(_vm.parentComponent.info.name))]) : _vm._e(), _vm._v(" " + _vm._s(_vm.current.info ? ' - ' + _vm.current.info.name : ''))])], 1), _vm._v(" "), (_vm.selectField.value === '属性') ? _c('attributes', {
    staticClass: "attributes-content"
  }) : _vm._e(), _vm._v(" "), (_vm.selectField.value === '组件树') ? _c('component-tree', {
    staticClass: "component-tree",
    attrs: {
      "components": _vm.$store.state.components.filter(function (c) { return !c.parentId; })
    }
  }) : _vm._e(), _vm._v(" "), (_vm.current.info) ? _c('div', {
    staticClass: "attributes-bottom"
  }, [_c('mu-flat-button', {
    attrs: {
      "label": "UI文档"
    },
    on: {
      "click": _vm.openUiDocument
    }
  }), _vm._v(" "), _c('mu-flat-button', {
    attrs: {
      "label": "操作"
    },
    on: {
      "click": _vm.oprate
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('mu-col', {
    staticClass: "preview",
    attrs: {
      "width": _vm.width.preview,
      "tablet": _vm.width.preview,
      "desktop": _vm.width.preview
    }
  }, [_c('preview', {
    ref: "preview"
  })], 1), _vm._v(" "), _c('mu-col', {
    staticClass: "components",
    attrs: {
      "width": _vm.width.components,
      "tablet": _vm.width.components,
      "desktop": _vm.width.components
    }
  }, [_c('components', {
    ref: "components"
  })], 1)], 1), _vm._v(" "), _c('mu-dialog', {
    attrs: {
      "open": _vm.setting.open,
      "title": "设置",
      "scrollable": ""
    },
    on: {
      "close": function($event) {
        _vm.setting.open = false
      }
    }
  }, [_c('br'), _vm._v(" "), _c('mu-checkbox', {
    attrs: {
      "label": "选中边框效果"
    },
    on: {
      "change": _vm.setSelectEffect
    },
    model: {
      value: (_vm.setting.selectEffect),
      callback: function($$v) {
        _vm.setting.selectEffect = $$v
      },
      expression: "setting.selectEffect"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('mu-flat-button', {
    attrs: {
      "primary": "",
      "label": "关闭"
    },
    on: {
      "click": function($event) {
        _vm.setting.open = false
      }
    },
    slot: "actions"
  })], 1), _vm._v(" "), _c('mu-dialog', {
    attrs: {
      "open": _vm.share.open,
      "title": "分享当前布局",
      "scrollable": ""
    },
    on: {
      "close": function($event) {
        _vm.share.open = false
      }
    }
  }, [_c('br'), _vm._v(" "), (!_vm.share.url) ? _c('mu-flat-button', {
    attrs: {
      "label": "点击生成"
    },
    on: {
      "click": _vm.createShare
    }
  }) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('mu-text-field', {
    attrs: {
      "type": "url",
      "disabled": true,
      "hintText": "分享地址",
      "label": "分享地址",
      "fullWidth": ""
    },
    model: {
      value: (_vm.share.url),
      callback: function($$v) {
        _vm.share.url = $$v
      },
      expression: "share.url"
    }
  }), _vm._v(" "), _c('mu-text-field', {
    attrs: {
      "type": "url",
      "disabled": true,
      "label": "体验地址",
      "hintText": "体验地址",
      "fullWidth": ""
    },
    model: {
      value: (_vm.share.experience),
      callback: function($$v) {
        _vm.share.experience = $$v
      },
      expression: "share.experience"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('mu-flat-button', {
    attrs: {
      "primary": "",
      "label": "关闭"
    },
    on: {
      "click": function($event) {
        _vm.share.open = false
      }
    },
    slot: "actions"
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1acf11f7","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/main.vue
// module id = 530
// module chunks = 1